module.exports = __webpack_public_path__ + "static/media/youtube-viewer.54c1beb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/youtube-viewer.png
// module id = 74
// module chunks = 0